
namespace RedBullMOBILE360.SMSCodes {

    @Serenity.Decorators.registerClass()
    export class ServiceSmsGrid extends Serenity.EntityGrid<ServiceSmsRow, any> {
        protected getColumnsKey() { return ServiceSmsColumns.columnsKey; }
        protected getDialogType() { return ServiceSmsDialog; }
        protected getIdProperty() { return ServiceSmsRow.idProperty; }
        protected getInsertPermission() { return ServiceSmsRow.insertPermission; }
        protected getLocalTextPrefix() { return ServiceSmsRow.localTextPrefix; }
        protected getService() { return ServiceSmsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}